module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAfElEQVR4AWOgD9CuhyKtRgatBiAJ4WIiVA1a9Wy65YrWyczalUA2YQ3W3pF91ZrFqWp91drazskM6s0ENATFhF5eq7h/vsr5VUo2fvEMqi0ENAiYlNu5u1s42Nm4e3MaVgM9Q8gPmg0gU1WbgSRENU4N5wTViETDQsOgBABbSYS7fyqS1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LI.png
// module id = 1192
// module chunks = 0